module.exports = __webpack_public_path__ + "static/media/hub_twitter_image.addfc63a.jpg";